var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('keep-alive',[(_vm.check(_vm.code))?[_vm._t("default")]:[_vm._t("unpermitted")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }